import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Typography,
  Button,
  InputNumber,
  Divider,
  Tooltip,
  notification,
} from "antd";
import moment from "moment";

import { FormattedMessage } from "react-intl";
import {
  getTranslatedValue,
  successMsg,
  toCalculateResultNewVersion,
} from "../utils/Utils";
import { toAddAssessment, toUpdateAssessment } from "../utils/APIs";
import { useLocation, useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const PracticeForm = ({
  showMoreInfo = false,
  showBtns = true,
  selected,
  action,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [id, setId] = useState(null != location.state ? location.state.id : -1);
  const [toSave, setToSave] = useState(false);
  const [expanded, setExpanded] = useState(showMoreInfo);
  const [template, setTemplate] = useState(selected);
  const toggleExpanded = () => setExpanded(!expanded);

  useEffect(() => {
    setTemplate({ ...selected, assessmentId: id });
  }, [selected]);

  const onChange = (value, fieldName, type) => {
    const l__template = { ...template };
    l__template.results.questions.map((el, key) => {
      if (el.fieldName === fieldName && type === 1) el.alignersValue = value;
      if (el.fieldName === fieldName && type === 2) el.bracesValue = value;
    });

    setTemplate(l__template);
  };

  const toCheckFields = () => {
    const items = template?.results?.questions
      .filter((_, x) => x !== 2)
      .filter((el) => el.alignersValue == "" || el.bracesValue == "");
    return items.length > 0;
  };

  const toAddOrUpdate = (status) => {
    if (toCheckFields()) {
      notification.error({
        message: getTranslatedValue("validationFailed"),
        description: <></>,
        duration: 5,
      });

      setToSave(true);
      return;
    }
    const calculatedValues = toCalculateResultNewVersion(template);
    //return;

    if (id == -1) {
      toAddAssessment(template, calculatedValues, -1, -1, status).then(
        (res) => {
          if (status == 1) {
            navigate("/results", {
              state: { id: res.id },
            });
          } else {
            successMsg(getTranslatedValue("infoSaved"));
          }
        }
      );
    } else {
      toUpdateAssessment(template, calculatedValues, -1, -1, status).then(
        (res) => {
          if (status == 1) {
            navigate("/results", { state: { id: res.id } });
          } else {
            successMsg(getTranslatedValue("infoSaved"));
          }
        }
      );
    }
  };
  const visibleElements =
    template?.results?.questions &&
    template?.results?.questions.filter((el) => expanded || el.alwaysVisible);

  return (
    <div className="roi--form-container">
      <Title level={4} className="roi--form-title">
        <FormattedMessage id="treatmentStatistics" />
      </Title>

      <Row gutter={16} style={{ marginBottom: 16 }}>
        <Col span={18} />
        <Col span={3} className="roi--form-tags-inputs">
          <Text>
            <FormattedMessage id="aligners" />
          </Text>
        </Col>
        <Col span={3} className="roi--form-tags-inputs">
          <Text>
            <FormattedMessage id="braces" />
          </Text>
        </Col>
      </Row>

      {visibleElements
        .filter((_, x) => x !== 2)
        .map((field, key) => (
          <>
            {key === 2 && (
              <p className="roi--form-subtitle">
                <FormattedMessage id="statisticsTitle" />
              </p>
            )}
            {key === 5 && (
              <p className="roi--form-subtitle">
                <FormattedMessage id="timeSpentTitle" />
              </p>
            )}
            <Row
              key={field.key}
              gutter={16}
              align="middle"
              style={{
                padding: "0.5rem",
                backgroundColor:
                  key === 1 || key === 4 || key === 7 ? "#F5F8FA" : "white",
              }}
              className={` ${expanded && key > 2 ? "fade-in" : ""}`}
            >
              <Col span={18}>
                <Text className="roi--form-label">
                  <FormattedMessage id={field.fieldName} />
                  <Tooltip
                    color="#EBEBEA"
                    fontFamily="Gotham"
                    fontSize="20px"
                    style={{ textColor: "#6a6e80" }}
                    placement="rightTop"
                    title={<FormattedMessage id={field.tooltip} />}
                  >
                    <img
                      src="/images/icons/bull-info.svg"
                      className="roi--form-info-img"
                    />
                  </Tooltip>
                </Text>
              </Col>
              <Col span={3}>
                <InputNumber
                  type="number"
                  className={
                    field.alignersValue == "" && toSave
                      ? "roi--error-input"
                      : ""
                  }
                  controls={false}
                  style={{ width: "100%" }}
                  size="middle"
                  min={0}
                  placeholder={
                    field.alignersValue !== "" ? field.alignersValue : "-"
                  }
                  value={!isNaN(field.alignersValue) && field.alignersValue}
                  onBlur={(e) => onChange(e.target.value, field.fieldName, 1)}
                  variant="underlined"
                />
              </Col>
              <Col span={3}>
                <InputNumber
                  type="number"
                  controls={false}
                  style={{ width: "100%" }}
                  size="middle"
                  className={
                    field.bracesValue == "" && toSave ? "roi--error-input" : ""
                  }
                  min={0}
                  placeholder={
                    field.bracesValue !== "" ? field.bracesValue : "-"
                  }
                  value={!isNaN(field.bracesValue) && field.bracesValue}
                  onBlur={(e) => onChange(e.target.value, field.fieldName, 2)}
                  variant="underlined"
                />
              </Col>
            </Row>
            <Divider style={{ margin: 0, backgroundColor: "#CBD2D9" }} />
          </>
        ))}

      <Row style={{ marginBottom: 20 }}>
        <Col span={24}>
          <Button
            type="link"
            className="roi--info-button"
            onClick={toggleExpanded}
            icon={
              expanded ? (
                <img
                  src="/images/icons/arrowUp.svg"
                  alt="arrow up"
                  width={13}
                />
              ) : (
                <img
                  src="/images/icons/arrowForword.svg"
                  alt="arrow forward"
                  width={7}
                />
              )
            }
            dir="rtl"
          >
            {expanded ? (
              <span className="roi--info-arrow">
                <FormattedMessage id="less" />
              </span>
            ) : (
              <span className="roi--info-arrow">
                <FormattedMessage id="more" />
              </span>
            )}
          </Button>
        </Col>
      </Row>
      {action}
      {showBtns && (
        <Row justify="center" gutter={16}>
          <Col>
            <Button
              className="roi--button-form roi--button-saved"
              onClick={() => toAddOrUpdate(2)}
            >
              <FormattedMessage id="saveForLater" />
            </Button>
          </Col>
          <Col>
            <Button
              className="roi--button-form roi--button-generate"
              onClick={() => toAddOrUpdate(1)}
            >
              <FormattedMessage id="generateSimulation" />
            </Button>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default PracticeForm;
